// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { NavLink } from "react-router-dom";
import { startsWith } from "../../../../../../io/hyperify/core/functions/startsWith";
import { ComponentUtils } from "../../../../../../io/hyperify/frontend/components/utils/ComponentUtils";
import { ARTICLE_HEADER_CLASS_NAME } from "../../../../core/constants/className";
import { ReactNode } from "react";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./ArticleHeader.scss";

export interface ArticleHeaderProps {
  readonly t: TranslationFunction;
  readonly className?: string;
  readonly title?: string;
  readonly description?: string;
  readonly dark ?: boolean;
  readonly children ?: ReactNode;
  readonly primaryButtonTo?: string;
  readonly primaryButtonText?: string;
  readonly secondaryButtonTo?: string;
  readonly secondaryButtonText?: string;
}

export function ArticleHeader (props: ArticleHeaderProps) {
  const className: string | undefined = props?.className;
  const t: TranslationFunction | undefined = props?.t;
  const title = props?.title;
  const description = props?.description;
  const dark = props?.dark ?? false;
  const children = props?.children ?? null;
  const secondaryButtonTo = props?.secondaryButtonTo;
  const secondaryButtonText = props?.secondaryButtonText;
  const isSecondaryLink: boolean = !!(secondaryButtonTo && startsWith(secondaryButtonTo, 'https://'));

  const primaryButtonTo = props?.primaryButtonTo;
  const primaryButtonText = props?.primaryButtonText;
  const isPrimaryLink: boolean = !!(primaryButtonTo && startsWith(primaryButtonTo, 'https://'));


  return (
    <header className={`${
        ARTICLE_HEADER_CLASS_NAME
      + (className ? ' ' + className : '')
      + (dark?' '+ARTICLE_HEADER_CLASS_NAME+'-dark': '')
    }`}>

      <h1 className={ARTICLE_HEADER_CLASS_NAME+'-title'}>{title}</h1>

      <>{description ? (
          ComponentUtils.prepareParagraphNodes(
              t,
              [description],
              undefined,
              undefined
          )
      ) : null}
      </>

      <div className={`${ARTICLE_HEADER_CLASS_NAME}-buttons`}>

        {primaryButtonTo ? (
            isPrimaryLink ? (
                <a
                    href={primaryButtonTo}
                    className={`${ARTICLE_HEADER_CLASS_NAME}-buttons-button ${ARTICLE_HEADER_CLASS_NAME}-primary-button`}
                >{primaryButtonText ?? 'no text'}</a>
            ) : (
                <NavLink
                    to={primaryButtonTo}
                    className={`${ARTICLE_HEADER_CLASS_NAME}-buttons-button ${ARTICLE_HEADER_CLASS_NAME}-primary-button`}
                >{primaryButtonText ?? 'no text'}</NavLink>
            )
        ) : null}

        {secondaryButtonTo ? (
            isSecondaryLink ? (
                <a
                    href={secondaryButtonTo}
                    className={`${ARTICLE_HEADER_CLASS_NAME}-buttons-button ${ARTICLE_HEADER_CLASS_NAME}-secondary-button`}
                >{secondaryButtonText ?? 'no text'}</a>
            ) : (
                <NavLink
                    to={secondaryButtonTo}
                    className={`${ARTICLE_HEADER_CLASS_NAME}-buttons-button ${ARTICLE_HEADER_CLASS_NAME}-secondary-button`}
                >{secondaryButtonText ?? 'no text'}</NavLink>
            )
        ) : null}

      </div>

      {children}

    </header>
  );
}
